<template>
  <VWidget enable-footer-actions css-class="hover-border">
    <template slot="title">{{ board.display }}</template>
    <template slot="content">
      <p>{{ board.description }}</p>
      <AvatarList :users="board.users" align-right />
    </template>
    <template slot="footer-actions">
      <v-btn small icon @click="goToBoard">
        <v-icon small v-text="$vuetify.icons.values.view" />
      </v-btn>
    </template>
  </VWidget>
</template>

<script>
import { AvatarList } from '@argon/iam/components'
import { VWidget } from '@argon/app/components'
export default {
  name: 'BoardCard',
  components: { VWidget, AvatarList },
  props: {
    board: { type: Object, required: true },
    show: { type: Function, required: true }
  },
  methods: {
    goToBoard() {
      this.show(this.board.refname)
    }
  }
}
</script>

<style></style>
